import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface OfflineRecordingReplaceDialogProps {
  open: boolean;
  /** On to the microphone question, and the recording that follows it. */
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * The question in front of recording a meeting this user already recorded.
 *
 * Recording again is worth offering — stopping too early is the ordinary
 * mistake here. But each user keeps one recording per meeting, so the first one
 * and its transcript are what the second costs, said before the microphone
 * picker rather than after the recording.
 *
 * It is asked on its own, ahead of the microphone question: somebody who
 * reached this by habit should meet the cost first, while cancelling still
 * costs them nothing.
 */
export function OfflineRecordingReplaceDialog({
  open,
  onConfirm,
  onCancel,
}: OfflineRecordingReplaceDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent size='md'>
        <DialogHeader>
          <DialogTitle>{m.meeting_offline_replace_title()}</DialogTitle>
        </DialogHeader>

        <div className='px-5 py-4'>
          <p className='text-sm text-ink-body'>{m.meeting_offline_replace_body()}</p>
        </div>

        <DialogFooter>
          <Button size='sm' variant='quiet' onClick={onCancel}>
            {m.meeting_cancel()}
          </Button>
          <Button size='sm' onClick={onConfirm}>
            {m.meeting_offline_replace_confirm()}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
